import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePicker } from '@ionic-native/date-picker/ngx';
import { AlertController, LoadingController, ModalController, NavParams, Platform, ToastController } from '@ionic/angular';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { Country, PlayerHomeInfo, PlayerInfo } from 'src/data/mygolf.data';
import { JsonService } from 'src/json-util';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { PlayerService } from 'src/providers/player-service/player-service';
import { PlayerHomeActions } from 'src/redux/player-home';
import { DeleteRoomModalComponent } from '../package-details/package-booking/delete-room-modal/delete-room-modal.component';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.page.html',
  styleUrls: ['./edit-profile.page.scss'],
})
export class EditProfilePage {
  public homeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;
  public type: string;
  public player: PlayerInfo;
  public dob: any;
  public dobDisplay: string;
  public countryList: Array<Country>;
  public flagUrl: string;
  public previousEmail: string;
  public newPassword: string;
  public confirmPassword: string;
  constructor(
    private datePicker: DatePicker,
    private platform: Platform,
    private loadingCtl: LoadingController,
    private toastCtl: ToastController,
    private alertCtl: AlertController,
    private playerHomeActions: PlayerHomeActions,
    private playerService: PlayerService,
    private modalCtl: ModalController,
    private router: Router,
    private navParams: NavParams,
  ) {
    this.type = navParams.get('type')
    this.homeInfo$ = navParams.get("homeInfo")
    this.player$ = navParams.get('player')
    if (!this.player$) {
      this.player$ = this.homeInfo$.pipe(map((playerHomeInfo: PlayerHomeInfo) => playerHomeInfo.player));//Rajiv Jha
    }
    this.player$.pipe(take(1))
      .pipe(map((player: PlayerInfo) => {
        return player.birthdate;
      })).pipe(filter(Boolean))
      .subscribe((birthdate) => {
        this.dob = moment(birthdate).format("YYYY-MM-DD");
        console.debug("date of birth ", birthdate, moment(birthdate).format("YYYY-MM-DD"), this.dob);
        this.dobDisplay = moment(birthdate).format("MMM D, YYYY");
      });

  }
  ionViewWillEnter() {
    this.getCountry();

    this.previousEmail = this.player.email;

  }
  getCountry() {
    this.playerService.getCountryList()
      .subscribe((data: Array<Country>) => {

        this.countryList = data;

        this.player$.pipe(take(1))
          .subscribe((player: PlayerInfo) => {
            this.player = JsonService.clone(player);
            console.log(this.player, '---Player---')
            this.player.countryId = this.player.addressInfo.countryId
            this.player.countryName = this.player.addressInfo.countryName
          });
      });
  }
  getFlagUrl(flagUrl: string) {
    if (flagUrl == null) return null;
    else {
      let flagIcon = flagUrl.split("/");
      return "img/flag/" + flagIcon[2];
    }
  }
  async updateProfile() {
    let _password;
    if (!this.player.email || this.player.email.length === 0) {
      MessageDisplayUtil.showErrorToast('Please enter valid email address', this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    if (this.hasEmailChanged()) {
      if (!this.player.email) {
        MessageDisplayUtil.showErrorToast('Please enter valid email address', this.platform, this.toastCtl, 5000, "bottom");
        return false;
      }
      if (!this.newPassword) {
        MessageDisplayUtil.showErrorToast('Please enter new password', this.platform, this.toastCtl, 5000, "bottom");
        return false;
      } else if (!this.confirmPassword) {
        MessageDisplayUtil.showErrorToast('Please confirm your new password', this.platform, this.toastCtl, 5000, "bottom");
        return false;
      }
      if (this.newPassword !== this.confirmPassword) {
        MessageDisplayUtil.showErrorToast('Please make sure your new and confirmed password are matched', this.platform, this.toastCtl, 5000, "bottom");
        return false;
      }
      else if (this.newPassword === this.confirmPassword) {
        _password = this.newPassword;
        this.player.password = this.newPassword;
      }
    }
    if (!this.player.phone) {
      MessageDisplayUtil.showErrorToast('Please enter valid Mobile numbers for better experience in the future',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    let _phoneLength = 10
    if (!this.player.phone.startsWith('0')) _phoneLength = 11;
    if ((this.player.phone && this.player.phone.length > 0 && this.player.phone.length < _phoneLength)) {
      MessageDisplayUtil.showErrorToast('Since Mobile number starts with ' + this.player.phone[0] + '. Please enter Mobile number more than ' + _phoneLength + ' digits for better experience in the future',
        this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    let busy = await this.loadingCtl.create({
      message: "Updating profile..."
    });
    console.debug("updating profile ", this.player.birthdate, this.dob, moment(this.dob).toDate())
    if (this.dob) this.player.birthdate = moment(this.dob).toDate();
    let friend = (this.type === 'friendProfile');
    this.playerHomeActions.updatePlayerProfile(this.player, friend)
      .subscribe((result: boolean) => {
        busy.dismiss().then(() => {
          if (friend) {
            this.player$.pipe(take(1)).subscribe((curPlayer: PlayerInfo) => {
              curPlayer.firstName = this.player.firstName;
              curPlayer.lastName = this.player.lastName;
              curPlayer.playerName = this.player.firstName
                + " " + this.player.lastName
              curPlayer.email = this.player.email;
              curPlayer.phone = this.player.phone;
              curPlayer.gender = this.player.gender;
              curPlayer.teeOffFrom = this.player.teeOffFrom;
              curPlayer.handicap = this.player.handicap;
              if(this.dob) curPlayer.birthdate = moment(this.dob, "YYYY-MM-DD").toDate();
              curPlayer.countryId = this.player.countryId;
              curPlayer.nationalityId = this.player.nationalityId;
            });
          }
          if (result) {
            setTimeout(() => {
              this.modalCtl.dismiss();
            }, 1000)
          }
        });
      }), (error) => {
        busy.dismiss().then(() => {
          let msg = MessageDisplayUtil.getErrorMessage(error, "Error updating player profile");
          MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
        })
      }
  }
  hasEmailChanged() {
    if (!this.previousEmail) return false;
    if (this.previousEmail !== this.player.email) return true;
    else return false;
  }
  onHomeClick() {
    this.router.navigate(['player-home']);
  }
  onCancelClick() {
    this.modalCtl.dismiss();
  }
  capacitor(): boolean {
    return this.platform.is("capacitor");
  }
  /**
      * This method is called in Cordova environment. This will display the date and
      */
  onBirthDateClick() {
    this.datePicker.show({
      mode: "date",
      date: moment(this.dob,"YYYY-MM-DD").toDate()
    }).then((date: Date) => {
      this.dob = moment(date).format("YYYY-MM-DD");
      this.dobDisplay = moment(date).format("MMM D, YYYY");
    });
  }

  isModalOpen: boolean = false;
  async nationalitySelected() {
    // Guard for the not open multiple time modal open 
    if (this.isModalOpen) {
      return;
    }
    this.isModalOpen = true;
    try {
      const nationalityModal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'selectClub',
          countryList: this.countryList,
          countryId: this.player.nationalityId,
          header: 'Select Country'
        },
        showBackdrop: true,
        mode: 'ios'
      })
      await nationalityModal.present();
      nationalityModal.onDidDismiss().then((data) => {
        this.isModalOpen = false;
        if (data?.data) {
          console.log('data?.data: ', data?.data);
          this.player.nationalityId = data?.data?.id;
          this.player.nationalityName = data?.data?.name
        }
      })
    } 
    catch (error) {
      this.isModalOpen = false; 
    }
  }

  async residingSelected() {
    if(this.isModalOpen){
      return true;
    }
    this.isModalOpen = true;
    try {      
      const residingModal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'selectClub',
          countryList: this.countryList,
          countryId: this.player.countryId,
          header: 'Select Country'
        },
        showBackdrop: true,
        mode: 'ios'
      })
      await residingModal.present();
      residingModal.onDidDismiss().then((data) => {
        this.isModalOpen=false
        if (data?.data) {
          this.player.countryId = data?.data?.id;
          this.player.countryName = data?.data?.name
        }
      })
    } 
    catch (error) {
      this.isModalOpen=false
    }
  }




}
